import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import VehicleStock from "@/pages/VehicleStock";
import FinanceList from "@/pages/FinanceList";
import FinanceDetail from "@/pages/FinanceDetail";
import InvoicesList from "@/pages/InvoicesList";
import Invoice from "@/pages/Invoice";
import Transfers from "@/pages/Transfers";
import Users from "@/pages/Users";
import Reports from "@/pages/Reports";
import Audit from "@/pages/Audit";
import Incentives from "@/pages/Incentives";
import Ledger from "@/pages/Ledger";
import Quotations from "@/pages/Quotations";
import ChangePassword from "@/pages/ChangePassword";
import IdleTimer from "@/components/IdleTimer";

const P = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>
    <Layout>
      <IdleTimer />
      {children}
    </Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={<P><Dashboard /></P>} />
          <Route path="/vehicles" element={<P><VehicleStock /></P>} />
          <Route path="/finance" element={<P roles={["admin", "finance", "branch"]}><FinanceList /></P>} />
          <Route path="/finance/:vehicleId" element={<P roles={["admin", "finance", "branch"]}><FinanceDetail /></P>} />
          <Route path="/invoices" element={<P roles={["admin", "finance", "branch"]}><InvoicesList /></P>} />
          <Route path="/invoice/:vehicleId" element={<P><Invoice /></P>} />
          <Route path="/transfers" element={<P roles={["admin", "branch", "pdi"]}><Transfers /></P>} />
          <Route path="/users" element={<P roles={["admin"]}><Users /></P>} />
          <Route path="/reports" element={<P roles={["admin", "finance"]}><Reports /></P>} />
          <Route path="/audit" element={<P roles={["admin"]}><Audit /></P>} />
          <Route path="/incentives" element={<P roles={["admin"]}><Incentives /></P>} />
          <Route path="/quotations" element={<P roles={["admin", "branch", "finance"]}><Quotations /></P>} />
          <Route path="/ledger" element={<P roles={["admin", "branch"]}><Ledger /></P>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
